enum SMACertificateState {
    None = 0,
    // En cours de cr�ation
    Created = 1,
    // Valid� mais en attente signature client
    ClientValidated,
    // Valid� par superviseur
    SupervisorValidated,
    // Archivage
    Archived
}

export default SMACertificateState;